var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcHomeProductosconalertas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,54.65A24.65,24.65,0,1,1,54.65,30,24.64,24.64,0,0,1,30,54.65ZM26.71,21a1.65,1.65,0,0,1,1.66-1.65h3.26A1.67,1.67,0,0,1,33.29,21V31.63a1.65,1.65,0,0,1-1.66,1.66H28.37a1.67,1.67,0,0,1-1.66-1.66Zm0,16.44a1.66,1.66,0,0,1,1.66-1.66h3.26a1.66,1.66,0,0,1,1.66,1.66v3.26a1.65,1.65,0,0,1-1.66,1.66H28.37a1.66,1.66,0,0,1-1.66-1.66ZM30,48.08A18.08,18.08,0,1,0,11.92,30,18.08,18.08,0,0,0,30,48.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHomeProductosconalertas);
export default __webpack_public_path__ + "static/media/DC_Home_Productos con alertas.d6f0192fee91abbb2abd47d44794db5a.svg";
export { ForwardRef as ReactComponent };